import React from "react";
import { useTheme } from "@/contexts/ThemeContext";

// Brand logos uploaded by the user
const DARK_LOGO =
  "https://customer-assets.emergentagent.com/job_influencer-ops-9/artifacts/t9g0p21w_White%20Trans.png"; // white on dark
const LIGHT_LOGO =
  "https://customer-assets.emergentagent.com/job_influencer-ops-9/artifacts/elmkyshc_Black%20Trans.png"; // black on light

const Logo = ({ className = "h-8 w-auto", showWordmark = false, testid = "brand-logo" }) => {
  const { theme } = useTheme();
  const src = theme === "light" ? LIGHT_LOGO : DARK_LOGO;
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <img
        src={src}
        alt="Bagfluence"
        className={className}
        draggable={false}
      />
      {showWordmark && (
        <span className="font-semibold tracking-tighter text-zinc-50 dark:text-zinc-50">
          Bagfluence
        </span>
      )}
    </span>
  );
};

export default Logo;
